import { Controller } from '@hotwired/stimulus';

// Homepage: show header "Get Instant Access" only after the hero CTA leaves the viewport.
export default class extends Controller {
  static targets = ['headerCta'];

  connect() {
    this.heroCta = document.getElementById('homepage-hero-cta');
    if (!this.heroCta || !this.hasHeaderCtaTarget) {
      this.setShowInstantAccess(false);
      return;
    }

    this.onHeroVisibility = this.onHeroVisibility.bind(this);
    this.observer = new IntersectionObserver(this.onHeroVisibility, {
      threshold: 0,
      rootMargin: '0px 0px -8% 0px'
    });
    this.observer.observe(this.heroCta);
  }

  disconnect() {
    this.observer?.disconnect();
    this.element.classList.remove('home-header--show-instant-access');
  }

  onHeroVisibility(entries) {
    const entry = entries[0];
    if (!entry) return;
    this.setShowInstantAccess(!entry.isIntersecting);
  }

  setShowInstantAccess(show) {
    if (this.instantAccessVisible === show) return;
    this.instantAccessVisible = show;
    this.element.classList.toggle('home-header--show-instant-access', show);
  }
}
